//router.js
import React from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from "react-router-dom";

import Frame from '../frame/Frame';
import Home from '../frame/Home';

import Index from '../pages/index/Index';
import Notice from '../pages/notice/Index';
import Login from '../pages/login/Index';
import Filling from '../pages/filling/Index';
import History from '../pages/history/Index';
import HistoryList from '../pages/historyList/Index';
import Schedule from '../pages/schedule/Index';
import Basis from '../pages/basis/Index';
import Judge from '../pages/judge/Index';
import Query from '../pages/query/Index';
import Info from '../pages/info/index';
import Info2 from '../pages/info2/index';

class FrameRouter extends React.Component {
    render() {
        return(
            <Router basename="/grade-individual-app">
                <Route exact path="/" component={Home}/>
                <Route path="/home" render={ ({match}) => {
                    // let access =localStorage.getItem("_user_access_");
                    // let token =localStorage.getItem("_user_token_"); 
                    let access = true;
                    let token = true; 

                    let URL = window.location.pathname;
                    if( URL.indexOf('null')>-1)
                    {
                        URL='/home'
                    }
                    else
                    {
                        URL = URL.replace("/", "");
                    }
                   localStorage.setItem("_redirect_source_url", URL);
                   
                    if( access || token )
                    {
                        let pathBase = match.path;

                        return(
                            <Router basename="/grade-individual-app">
                                <Switch>
                                    <Route exact path={ pathBase + "/login" } component={Login}></Route>
                                    <Route exact path={ pathBase + "/filling" } component={Filling}></Route>
                                    <Route exact path={ pathBase + "/history" } component={History}></Route>
                                    <Route exact path={ pathBase + "/historyList" } component={HistoryList}></Route>
                                    <Route exact path={ pathBase + "/schedule" } component={Schedule}></Route>
                                    <Route exact path={ pathBase + "/basis" } component={Basis}></Route>
                                    <Route exact path={ pathBase + "/judge" } component={Judge}></Route>
                                    <FrameRoute exact path={ pathBase + "/" } component={Home} model="home"/>
                                    <FrameRoute exact path={ pathBase + "/index" } component={Index}/>
                                    <FrameRoute exact path={ pathBase + "/notice" } component={Notice}/>
                                    <Route exact path={ pathBase + "/query" } component={Query}/>
                                    <Route exact path={ pathBase + "/info" } component={Info}/>
                                    <Route exact path={ pathBase + "/info2" } component={Info2}/>
                               </Switch> 
                            </Router>
                        )
                    }
                    else
                    {
                        return (
                            <Redirect to="/index"/>
                        )
                    }
                }} ></Route>    
            </Router>   
        )
    }
}

const FrameRoute = ({component: Component, model, ...rest}) => (
    <Route {...rest} render={(props) => (
        <Frame model={model} >
            <Component {...props} />
        </Frame>
    ) } />
)


export default FrameRouter


